import L from 'leaflet'
import { useEffect, useRef } from 'react'
import ReactDOMServer from 'react-dom/server'

import { useTheme } from '@mui/material'

import { useLeafletMapContext } from '../LeafletMap/LeafletMapContext'
import { LocationMarkerIcon } from '../MapIcons/LocationMarkerIcon'

export type AddressFieldMapControlProps = {
  latitude?: number
  longitude?: number
  zoomLevel?: number
  onMapRightClick?: (latitude: number, longitude: number, zoomLevel?: number) => void
}

export const AddressFieldMapControl: React.FC<AddressFieldMapControlProps> = ({ latitude, longitude, zoomLevel, onMapRightClick }) => {
  const { map } = useLeafletMapContext()
  const markerLayerGroupRef = useRef<L.LayerGroup>(L.layerGroup()) // Keep track of the markers to remove it later on
  const theme = useTheme()

  const createMarkerIcon = () => {
    const svgString = ReactDOMServer.renderToStaticMarkup(
      <LocationMarkerIcon
        content={''}
        fillColor={theme.palette.primary.main}
        className="depot-icon-svg"
      />,
    )

    return L.divIcon({
      html: svgString,
      className: '',
      iconSize: [30, 40],
      iconAnchor: [15, 40],
    })
  }

  // Display the updated latitude and longitude
  useEffect(() => {
    if (map && latitude && longitude) {
      markerLayerGroupRef.current.clearLayers()
      map.setView([latitude, longitude], zoomLevel ? zoomLevel : (map.getZoom() < 14 ? 14 : map.getZoom()))

      const marker = L.marker([latitude, longitude], { icon: createMarkerIcon() })

      marker.bindTooltip(
        `<p style='margin: 2px 0'><strong>Latitude:</strong> ${latitude}</p><p style='margin: 2px 0'><strong>Longitude:</strong> ${longitude}</p>`,
        {
          permanent: false,
          direction: 'right',
          offset: L.point(15, -25),
        },
      ).openTooltip()

      markerLayerGroupRef.current.addLayer(marker)
      markerLayerGroupRef.current.addTo(map)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, latitude, longitude, zoomLevel])

  // Map right click event listener
  useEffect(() => {
    if (map && onMapRightClick) {
      map.on('contextmenu', (ev) => {
        onMapRightClick(parseFloat(ev.latlng.lat.toFixed(6)), parseFloat(ev.latlng.lng.toFixed(6)), map.getZoom())
      })
    }
  }, [map, onMapRightClick])

  return null
}
